<app-page
  [isLoading]="(isLoadingPharmOrders$ | async) || (isLoading$ | async) || (notificationsState$ | async)?.isLoading"
  [error]="error$ | async"
>
  <p class="mt-0 font-semibold greeting-text text-5xl sm:text-6xl">
    <span class="font-light">Welcome Back, </span>{{ (patient$ | async)?.firstName | titlecase }}!
  </p>

  <div class="mb-6" *ngIf="(notificationsState$ | async)?.data">
    <div class="mb-3" *ngFor="let notification of (notificationsState$ | async)?.data">
      <app-notification [notification]="notification"></app-notification>
    </div>
  </div>

  <div class="flex align-items-start justify-content-between mb-5">
    <h1 class="my-0">Orders Activity</h1>
  </div>
  <app-orders-list
    [orders]="(activeOrders$ | async) || []"
    emptyMessageTitle="No active orders yet"
    emptyMessage="Any future active orders will appear here"
    [hasActionNeeded]="true"
  ></app-orders-list>
  <div *ngIf="newLeafPharmacyEnabled && (patient$ | async)?.isPharmacyPatient">
    <br /><br /><br />
    <div class="flex align-items-start justify-content-between mb-5">
      <h1 class="my-0">Pharmacy Activity</h1>
    </div>
    <app-pharm-orders-list
      [pharmOrders]="(activePharmOrders$ | async) || []"
      emptyMessageTitle="No active orders yet"
      emptyMessage="Any future active orders will appear here"
    ></app-pharm-orders-list>
  </div>
  <h1 class="mt-6">Manage Account</h1>
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-4">
      <div class="dashboard-tile-container">
        <div class="p-5">
          <img src="./assets/icons/divisional-icons/training-blue.svg" height="60px" alt="Training Icon" />
          <h2 class="mt-4 mb-0">Make a Payment</h2>
          <p class="mt-2 mb-0 p2">Pay your bill online!</p>
          <div class="cursor-pointer p1 mt-4 mb-0 w-max">
            <a *ngIf="billMatrixUrl" [href]="billMatrixUrl" target="_blank"
              >Pay Now<i class="ml-2 pi pi-arrow-right"></i
            ></a>
            <a *ngIf="!billMatrixUrl" routerLink="/payments">Pay Now<i class="ml-2 pi pi-arrow-right"></i></a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-4">
      <div class="dashboard-tile-container">
        <div class="p-5">
          <img src="./assets/icons/divisional-icons/clipboard-blue.svg" height="60px" alt="Clipboard Icon" />
          <h2 class="mt-4 mb-0">Orders</h2>
          <p class="mt-2 mb-0 p2">Authorize or track your orders!</p>
          <div class="cursor-pointer p1 mt-4 mb-0 w-max">
            <a routerLink="/orders">View Orders<i class="ml-2 pi pi-arrow-right"></i></a>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-4">
      <div class="dashboard-tile-container">
        <div class="p-5">
          <img src="./assets/icons/divisional-icons/user-blue.svg" height="60px" alt="User Icon" />
          <h2 class="mt-4 mb-0">Profile</h2>
          <p class="mt-2 mb-0 p2">Manage your insurance and addresses.</p>
          <div class="cursor-pointer p1 mt-4 mb-0 w-max">
            <a routerLink="/profile">Update Profile<i class="ml-2 pi pi-arrow-right"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-page>
